//@flow
import React from 'react';
import Foundation from 'components/organisms/foundation';
import FoundationMobile from 'components/organisms/foundation/foundationMobile';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';
import PastEventsBanner from 'components/organisms/pastEventsBanner';
import PastEventsBannerMobile from 'components/organisms/pastEventsBanner/pastEventsBannerMobile';

const PastEventsBannerTemplate = () => {
  const { isMobile, height } = useViewport();

  return (
    <div
      className={'main-container'}
      style={isMobile ? { height } : {}}
      id={'pastEventsBanner'}
    >
      {!isMobile ? (
        <PastEventsBanner />
      ) : (
        <PastEventsBannerMobile />
      )}
    </div>
  );
};
export default PastEventsBannerTemplate;